export const PARTS_OPTIONS = [
  { key: 'speaker', label: 'Haut-parleur' },
  { key: 'lcd', label: 'Écran' },
  { key: 'front_cam', label: 'Caméra avant' },
  { key: 'back_cam', label: 'Caméra arrière' },
  { key: 'microphone', label: 'Micro' },
  { key: 'fingerprint', label: 'Empreinte' },
  { key: 'home_button', label: 'Accueil' },
  { key: 'volume_button', label: 'Volume' },
  { key: 'power_button', label: 'Power' },
  { key: 'signal_carrier', label: 'Signal' },
  { key: 'battery', label: 'Batterie' },
  { key: 'wifi_bt', label: 'Wi-Fi/Bluetooth' },
  { key: 'ear_speaker', label: 'Écouteur' },
  { key: 'charging_port', label: 'Port charge' },
];

export const PARTS_LABEL_BY_KEY = Object.fromEntries(
  PARTS_OPTIONS.map((p) => [p.key, p.label]),
);
